import { createContext, useState, useMemo, useEffect } from "react";
import { createTheme } from "@mui/material/styles";

// Persisted color-mode key. Read once up-front so the very first paint matches
// the user's last choice (avoids a light→dark flash on reload).
const COLOR_MODE_KEY = "fx-color-mode";
const getInitialMode = () => {
  if (typeof window === "undefined") return "light";
  try {
    const saved = window.localStorage.getItem(COLOR_MODE_KEY);
    return saved === "dark" || saved === "light" ? saved : "light";
  } catch {
    return "light";
  }
};

// ============================================================================
// Color design tokens — refined navy + slate, professional & consistent
// ============================================================================
export const tokens = (mode) => ({
  ...(mode === "dark"
    ? {
        grey: {
          100: "#f8fafc",
          200: "#e2e8f0",
          300: "#cbd5e1",
          400: "#a5b2c6",
          500: "#8a9ab0",
          600: "#475569",
          700: "#334155",
          800: "#1e293b",
          900: "#0f172a",
        },
        primary: {
          100: "#e8ecf2",
          200: "#c4cdd9",
          300: "#8a9bb5",
          400: "#506890",
          500: "#1B365D",
          600: "#172e50",
          700: "#132643",
          800: "#0f1e36",
          900: "#0b1629",
        },
        secondary: {
          100: "#e0f2f8",
          200: "#b3dfec",
          300: "#80cce0",
          400: "#4db9d4",
          500: "#0087B4",
          600: "#00769d",
          700: "#006586",
          800: "#00546f",
          900: "#004358",
        },
        red: {
          100: "#fee2e2",
          200: "#fecaca",
          300: "#fca5a5",
          400: "#f87171",
          500: "#dc2626",
          600: "#b91c1c",
          700: "#991b1b",
          800: "#7f1d1d",
          900: "#450a0a",
        },
        green: {
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#16a34a",
          600: "#15803d",
          700: "#166534",
          800: "#14532d",
          900: "#052e16",
        },
        amber: {
          100: "#fef3c7",
          200: "#fde68a",
          300: "#fcd34d",
          400: "#fbbf24",
          500: "#d97706",
          600: "#b45309",
          700: "#92400e",
          800: "#78350f",
          900: "#451a03",
        },
        // Backward-compat aliases for legacy code paths
        greenAccent: {
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#16a34a",
          600: "#15803d",
          700: "#166534",
          800: "#14532d",
          900: "#052e16",
        },
        blueAccent: {
          100: "#e0f2f8",
          200: "#b3dfec",
          300: "#80cce0",
          400: "#4db9d4",
          500: "#0087B4",
          600: "#00769d",
          700: "#006586",
          800: "#00546f",
          900: "#004358",
        },
        redAccent: {
          100: "#fee2e2",
          200: "#fecaca",
          300: "#fca5a5",
          400: "#f87171",
          500: "#dc2626",
          600: "#b91c1c",
          700: "#991b1b",
          800: "#7f1d1d",
          900: "#450a0a",
        },
        orangeAccent: {
          100: "#fef3c7",
          200: "#fde68a",
          300: "#fcd34d",
          400: "#fbbf24",
          500: "#d97706",
          600: "#b45309",
          700: "#92400e",
          800: "#78350f",
          900: "#451a03",
        },
      }
    : {
        grey: {
          100: "#0f172a",
          200: "#1e293b",
          300: "#334155",
          400: "#475569",
          500: "#64748b",
          600: "#94a3b8",
          700: "#cbd5e1",
          800: "#e2e8f0",
          900: "#f8fafc",
        },
        primary: {
          100: "#e8ecf2",
          200: "#c4cdd9",
          300: "#8a9bb5",
          400: "#506890",
          500: "#1B365D",
          600: "#172e50",
          700: "#132643",
          800: "#0f1e36",
          900: "#0b1629",
        },
        secondary: {
          100: "#e0f2f8",
          200: "#b3dfec",
          300: "#80cce0",
          400: "#4db9d4",
          500: "#0087B4",
          600: "#00769d",
          700: "#006586",
          800: "#00546f",
          900: "#004358",
        },
        red: {
          100: "#fee2e2",
          200: "#fecaca",
          300: "#fca5a5",
          400: "#f87171",
          500: "#dc2626",
          600: "#b91c1c",
          700: "#991b1b",
          800: "#7f1d1d",
          900: "#450a0a",
        },
        green: {
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#16a34a",
          600: "#15803d",
          700: "#166534",
          800: "#14532d",
          900: "#052e16",
        },
        amber: {
          100: "#fef3c7",
          200: "#fde68a",
          300: "#fcd34d",
          400: "#fbbf24",
          500: "#d97706",
          600: "#b45309",
          700: "#92400e",
          800: "#78350f",
          900: "#451a03",
        },
        // Backward-compat aliases for legacy code paths
        greenAccent: {
          100: "#dcfce7",
          200: "#bbf7d0",
          300: "#86efac",
          400: "#4ade80",
          500: "#16a34a",
          600: "#15803d",
          700: "#166534",
          800: "#14532d",
          900: "#052e16",
        },
        blueAccent: {
          100: "#e0f2f8",
          200: "#b3dfec",
          300: "#80cce0",
          400: "#4db9d4",
          500: "#0087B4",
          600: "#00769d",
          700: "#006586",
          800: "#00546f",
          900: "#004358",
        },
        redAccent: {
          100: "#fee2e2",
          200: "#fecaca",
          300: "#fca5a5",
          400: "#f87171",
          500: "#dc2626",
          600: "#b91c1c",
          700: "#991b1b",
          800: "#7f1d1d",
          900: "#450a0a",
        },
        orangeAccent: {
          100: "#fef3c7",
          200: "#fde68a",
          300: "#fcd34d",
          400: "#fbbf24",
          500: "#d97706",
          600: "#b45309",
          700: "#92400e",
          800: "#78350f",
          900: "#451a03",
        },
      }),
});

// ============================================================================
// Font tokens — single source of truth (keep in sync with index.css)
//   - sans: UI text (loaded via index.html: Inter)
//   - mono: numeric / code values — curated SYSTEM stack, no external fetch.
//     Prefer referencing var(--fx-font-mono) in sx/style; use fonts.mono when
//     a CSS variable can't be used (e.g. SVG presentation attributes).
// ============================================================================
export const fonts = {
  sans: ["Inter", "system-ui", "-apple-system", "Segoe UI", "sans-serif"].join(","),
  mono:
    'ui-monospace, "SF Mono", SFMono-Regular, "Menlo", "Consolas", "Liberation Mono", "DejaVu Sans Mono", monospace',
};

// ============================================================================
// Surface & elevation tokens — used app-wide for consistency
// ============================================================================
export const surfaces = {
  canvas: "#f1f4f9",          // --surface-page (floor)
  paper: "#ffffff",           // --surface-card
  raised: "#ffffff",          // --surface-raised (drawer/popover/hover — lifts via shadow)
  inset: "#eef2f8",           // --surface-inset (wells, data panels — recessed)
  subtle: "#f8fafc",          // faint table-head / section tint
  border: "#e2e8f0",          // --border-hairline
  borderStrong: "#cbd5e1",    // --border-strong
  edgeHighlight: "rgba(255, 255, 255, 0.6)", // 1px top inner highlight on cards
  shadowSm: "0 1px 2px rgba(15, 23, 42, 0.04)",
  shadowMd: "0 1px 3px rgba(15, 23, 42, 0.06), 0 1px 2px rgba(15, 23, 42, 0.04)",
  shadowLg: "0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04)",
  shadowXl: "0 10px 24px rgba(15, 23, 42, 0.10), 0 4px 8px rgba(15, 23, 42, 0.06)",
};

// Dark-mode surface tokens — kept in sync with the html[data-theme="dark"]
// overrides in index.css so MUI chrome (Paper, Menu, Select, Dialog) matches
// the CSS-variable-driven page surfaces.
export const darkSurfaces = {
  canvas: "#0a0f1a",          // --surface-page (floor)
  paper: "#161f33",           // --surface-card
  raised: "#1e2a44",          // --surface-raised (drawer/popover/hover/selected)
  inset: "#0e1626",           // --surface-inset (wells, data panels — DARKER than card)
  subtle: "#1e2a44",          // faint section tint = a hair lifted in dark
  border: "rgba(150, 170, 210, 0.12)",       // --border-hairline
  borderStrong: "rgba(150, 170, 210, 0.22)", // --border-strong
  edgeHighlight: "rgba(255, 255, 255, 0.05)", // 1px top inner highlight on cards
  shadowSm: "0 1px 2px rgba(0, 0, 0, 0.45)",
  shadowMd: "0 1px 3px rgba(0, 0, 0, 0.5), 0 1px 2px rgba(0, 0, 0, 0.4)",
  shadowLg: "0 4px 12px rgba(0, 0, 0, 0.55), 0 2px 4px rgba(0, 0, 0, 0.4)",
  shadowXl: "0 10px 24px rgba(0, 0, 0, 0.6), 0 4px 8px rgba(0, 0, 0, 0.5)",
};

// Pick the right surface set for a given MUI palette mode.
export const surfacesFor = (mode) => (mode === "dark" ? darkSurfaces : surfaces);

// ============================================================================
// Theme settings — compact, professional, consistent
// ============================================================================
export const themeSettings = (mode) => {
  const colors = tokens(mode);
  // Shadow the module-level `surfaces` with the mode-aware set so every
  // `surfaces.xxx` reference below (background, dividers, component overrides)
  // adapts to dark mode without per-line edits.
  const surfaces = surfacesFor(mode);
  // ----------------------------------------------------------------------
  // Button system accents (1.3). Navy #1B365D reads dark against the dark
  // page, so in dark mode the primary CTA fill is a lifted, more saturated
  // navy that pops as an obvious call to action. Light mode keeps brand navy.
  // ----------------------------------------------------------------------
  const ctaFill = mode === "dark" ? "#274d80" : colors.primary[500];
  const ctaFillHover = mode === "dark" ? "#31609c" : colors.primary[700];
  const ctaFillActive = mode === "dark" ? "#1f3f6a" : colors.primary[800];
  return {
    palette: {
      mode: mode,
      primary: {
        main: colors.primary[500],
        light: colors.primary[300],
        dark: colors.primary[700],
        contrastText: "#ffffff",
      },
      secondary: {
        main: colors.secondary[500],
        light: colors.secondary[300],
        dark: colors.secondary[700],
        contrastText: "#ffffff",
      },
      error: {
        main: colors.red[500],
        light: colors.red[300],
        dark: colors.red[700],
      },
      warning: {
        main: colors.amber[500],
        light: colors.amber[300],
        dark: colors.amber[700],
      },
      success: {
        main: colors.green[500],
        light: colors.green[300],
        dark: colors.green[700],
      },
      info: {
        main: colors.secondary[500],
        light: colors.secondary[300],
        dark: colors.secondary[700],
      },
      background: {
        default: surfaces.canvas,
        paper: surfaces.paper,
      },
      text: {
        // Navy (#1B365D) is unreadable on a dark canvas — use the inverted
        // grey ramp top stop in dark mode.
        primary: mode === "dark" ? colors.grey[100] : colors.primary[500],
        secondary: mode === "dark" ? colors.grey[400] : colors.grey[500],
        disabled: mode === "dark" ? colors.grey[600] : colors.grey[600],
      },
      divider: surfaces.border,
    },
    typography: {
      fontFamily: ["Inter", "system-ui", "-apple-system", "Segoe UI", "sans-serif"].join(","),
      // Custom slot for numeric/code values — reference via theme.typography.fontFamilyMono
      fontFamilyMono: fonts.mono,
      fontSize: 13,
      htmlFontSize: 14,
      h1: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        fontSize: "1.875rem",
        fontWeight: 700,
        lineHeight: 1.25,
        letterSpacing: "-0.02em",
        color: colors.primary[500],
      },
      h2: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        fontSize: "1.5rem",
        fontWeight: 700,
        lineHeight: 1.3,
        letterSpacing: "-0.015em",
        color: colors.primary[500],
      },
      h3: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        fontSize: "1.25rem",
        fontWeight: 600,
        lineHeight: 1.35,
        letterSpacing: "-0.01em",
        color: colors.primary[500],
      },
      h4: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        fontSize: "1.0625rem",
        fontWeight: 600,
        lineHeight: 1.4,
        letterSpacing: "-0.005em",
        color: colors.primary[500],
      },
      h5: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        fontSize: "0.9375rem",
        fontWeight: 600,
        lineHeight: 1.45,
        color: colors.primary[500],
      },
      h6: {
        fontFamily: ["Inter", "system-ui", "sans-serif"].join(","),
        fontSize: "0.8125rem",
        fontWeight: 600,
        lineHeight: 1.5,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        color: colors.grey[500],
      },
      subtitle1: {
        fontSize: "0.9375rem",
        fontWeight: 500,
        lineHeight: 1.5,
        color: colors.primary[500],
      },
      subtitle2: {
        fontSize: "0.8125rem",
        fontWeight: 500,
        lineHeight: 1.5,
        color: colors.grey[500],
      },
      body1: {
        fontSize: "0.875rem",
        lineHeight: 1.55,
        color: colors.grey[400],
      },
      body2: {
        fontSize: "0.8125rem",
        lineHeight: 1.55,
        color: colors.grey[500],
      },
      caption: {
        fontSize: "0.75rem",
        lineHeight: 1.5,
        color: colors.grey[500],
        letterSpacing: "0.01em",
      },
      button: {
        fontSize: "0.8125rem",
        fontWeight: 600,
        letterSpacing: "0.01em",
        textTransform: "none",
      },
      overline: {
        fontSize: "0.6875rem",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: colors.grey[500],
      },
    },
    shape: {
      borderRadius: 6,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: surfaces.canvas,
            color: colors.primary[500],
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
          },
        },
      },
      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            textTransform: "none",
            borderRadius: 6,
            fontWeight: 600,
            fontSize: "0.8125rem",
            padding: "7px 16px",
            minHeight: 34,
            boxShadow: "none",
            transition: "background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease, color 0.15s ease",
            "&:hover": {
              boxShadow: "none",
            },
            // Disabled (1.3): visibly dimmer than the SAME variant when enabled,
            // never confusable with an enabled control. ~40% opacity + not-allowed.
            // pointerEvents:auto only surfaces the cursor — the `disabled` attribute
            // still blocks the click, and hover styles are neutralised below.
            "&.Mui-disabled": {
              opacity: 0.4,
              cursor: "not-allowed",
              pointerEvents: "auto",
              boxShadow: "none",
            },
          },
          sizeSmall: {
            padding: "4px 12px",
            minHeight: 28,
            fontSize: "0.75rem",
          },
          sizeLarge: {
            padding: "9px 20px",
            minHeight: 40,
            fontSize: "0.875rem",
          },
          // PRIMARY (1.3): solid brand-accent fill, white label, clear hover +
          // active. At most one per view. The obvious call to action.
          containedPrimary: {
            backgroundColor: ctaFill,
            color: "#ffffff",
            "&:hover": {
              backgroundColor: ctaFillHover,
            },
            "&:active": {
              backgroundColor: ctaFillActive,
            },
            "&.Mui-disabled": {
              backgroundColor: ctaFill,
              color: "#ffffff",
            },
          },
          containedSecondary: {
            backgroundColor: colors.secondary[500],
            color: "#ffffff",
            "&:hover": {
              backgroundColor: colors.secondary[700],
            },
            "&:active": {
              backgroundColor: colors.secondary[800],
            },
            "&.Mui-disabled": {
              backgroundColor: colors.secondary[500],
              color: "#ffffff",
            },
          },
          // SECONDARY (1.3): transparent fill, strong border, primary-text label.
          // Clearly clickable, clearly not the primary. Hover raises the surface.
          outlinedPrimary: {
            borderWidth: 1,
            borderColor: surfaces.borderStrong,
            color: mode === "dark" ? colors.grey[100] : colors.primary[500],
            backgroundColor: "transparent",
            "&:hover": {
              borderWidth: 1,
              borderColor: surfaces.borderStrong,
              backgroundColor: surfaces.raised,
            },
            "&.Mui-disabled": {
              borderColor: surfaces.borderStrong,
              color: mode === "dark" ? colors.grey[100] : colors.primary[500],
            },
          },
          outlined: {
            borderWidth: 1,
            borderColor: surfaces.borderStrong,
            color: mode === "dark" ? colors.grey[100] : colors.primary[500],
            backgroundColor: "transparent",
            "&:hover": {
              borderWidth: 1,
              borderColor: surfaces.borderStrong,
              backgroundColor: surfaces.raised,
            },
            "&.Mui-disabled": {
              borderColor: surfaces.borderStrong,
            },
          },
          // GHOST (1.3): text + icon only, no border, for low-weight actions.
          text: {
            color: mode === "dark" ? colors.grey[100] : colors.primary[500],
            "&:hover": {
              backgroundColor: mode === "dark"
                ? "rgba(255, 255, 255, 0.06)"
                : "rgba(27, 54, 93, 0.06)",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            transition: "background-color 0.15s ease, color 0.15s ease",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            // 1px top inner highlight + soft shadow so the card reads as lifted
            // off the page even when the hairline border is low-contrast (1.1).
            boxShadow: `inset 0 1px 0 ${surfaces.edgeHighlight}, ${surfaces.shadowSm}`,
            border: `1px solid ${surfaces.border}`,
            backgroundColor: surfaces.paper,
            backgroundImage: "none",
            transition: "border-color 0.15s ease, box-shadow 0.15s ease",
            "&:hover": {
              borderColor: surfaces.borderStrong,
            },
          },
        },
      },
      MuiPaper: {
        defaultProps: {
          elevation: 0,
        },
        styleOverrides: {
          root: {
            backgroundColor: surfaces.paper,
            backgroundImage: "none",
          },
          outlined: {
            border: `1px solid ${surfaces.border}`,
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          size: "small",
        },
        styleOverrides: {
          root: {
            borderRadius: 6,
            backgroundColor: surfaces.paper,
            "& .MuiOutlinedInput-root": {
              borderRadius: 6,
              backgroundColor: surfaces.paper,
              fontSize: "0.875rem",
              minHeight: 38,
              transition: "border-color 0.15s ease, box-shadow 0.15s ease",
              "& fieldset": {
                borderColor: surfaces.borderStrong,
                borderWidth: 1,
              },
              "&:hover fieldset": {
                borderColor: colors.primary[400],
                borderWidth: 1,
              },
              "&.Mui-focused fieldset": {
                borderColor: colors.primary[500],
                borderWidth: 1,
                boxShadow: `0 0 0 3px rgba(27, 54, 93, 0.10)`,
              },
            },
            // multiline grows naturally — undo the minHeight clamp so rows={N} works
            "& .MuiOutlinedInput-root.MuiInputBase-multiline": {
              minHeight: 0,
              padding: "10px 12px",
            },
            "& .MuiOutlinedInput-root.MuiInputBase-multiline .MuiInputBase-input": {
              padding: 0,
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.8125rem",
            },
            // shift the floating label down to match the new vertical padding
            "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
              transform: "translate(12px, 11px) scale(1)",
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            backgroundColor: surfaces.paper,
            fontSize: "0.875rem",
            transition: "border-color 0.15s ease, box-shadow 0.15s ease",
            "& .MuiOutlinedInput-notchedOutline": {
              borderColor: surfaces.borderStrong,
              borderWidth: 1,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.primary[400],
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: colors.primary[500],
              borderWidth: 1,
              boxShadow: `0 0 0 3px rgba(27, 54, 93, 0.10)`,
            },
          },
          input: {
            padding: "10px 12px",
            height: "auto",
            // input adornments need a touch more room
            "&.MuiInputBase-inputAdornedStart": {
              paddingLeft: 4,
            },
          },
          // Select inside an outlined input
          inputSizeSmall: {
            padding: "9px 12px",
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          root: {
            backgroundColor: surfaces.paper,
            borderRadius: 6,
            fontSize: "0.875rem",
          },
          select: {
            padding: "10px 12px",
            minHeight: "1.25em",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "0.8125rem",
            color: colors.grey[500],
          },
          outlined: {
            transform: "translate(12px, 11px) scale(1)",
            "&.MuiInputLabel-shrink": {
              transform: "translate(12px, -8px) scale(0.82)",
              backgroundColor: surfaces.paper,
              padding: "0 4px",
            },
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontSize: "0.7rem",
            marginLeft: 4,
            marginTop: 4,
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontSize: "0.6875rem",
            fontWeight: 600,
            height: 22,
            letterSpacing: "0.01em",
          },
          label: {
            paddingLeft: 8,
            paddingRight: 8,
          },
          outlined: {
            borderColor: surfaces.borderStrong,
            backgroundColor: surfaces.paper,
          },
        },
      },
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: surfaces.border,
          },
        },
      },
      MuiListItem: {
        styleOverrides: {
          root: {
            borderBottom: `1px solid ${surfaces.border}`,
          },
        },
      },
      MuiListItemButton: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            "&.Mui-selected": {
              backgroundColor: "rgba(27, 54, 93, 0.08)",
              "&:hover": {
                backgroundColor: "rgba(27, 54, 93, 0.12)",
              },
            },
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: colors.primary[800],
            color: "#ffffff",
            fontSize: "0.75rem",
            fontWeight: 500,
            padding: "6px 10px",
            borderRadius: 6,
            boxShadow: surfaces.shadowLg,
          },
          arrow: {
            color: colors.primary[800],
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.8125rem",
            minHeight: 40,
            padding: "8px 14px",
            letterSpacing: "0.01em",
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            minHeight: 40,
          },
          indicator: {
            height: 2,
            borderRadius: 1,
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: `1px solid ${surfaces.border}`,
            padding: "10px 14px",
            fontSize: "0.8125rem",
          },
          head: {
            fontWeight: 600,
            fontSize: "0.75rem",
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: colors.grey[500],
            backgroundColor: surfaces.subtle,
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            borderRadius: 10,
            boxShadow: surfaces.shadowXl,
          },
        },
      },
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            fontSize: "1rem",
            fontWeight: 600,
            padding: "14px 20px",
          },
        },
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            padding: "8px 20px 16px",
          },
        },
      },
      MuiDialogActions: {
        styleOverrides: {
          root: {
            padding: "10px 20px 16px",
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: 6,
            fontSize: "0.8125rem",
            padding: "6px 12px",
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            border: `1px solid ${surfaces.border}`,
            "&:before": { display: "none" },
            "&.Mui-expanded": { margin: 0 },
          },
        },
      },
      MuiLinearProgress: {
        styleOverrides: {
          root: {
            borderRadius: 4,
            height: 6,
            backgroundColor: surfaces.border,
          },
        },
      },
    },
  };
};

export const ColorModeContext = createContext({
  mode: "light",
  toggleColorMode: () => {},
  setColorMode: () => {},
});

export const useMode = () => {
  const [mode, setMode] = useState(getInitialMode);

  // Persist the choice and drive the CSS-variable theme via a <html data-theme>
  // attribute, so the page surfaces (defined in index.css) flip in lockstep
  // with the MUI theme.
  useEffect(() => {
    try {
      window.localStorage.setItem(COLOR_MODE_KEY, mode);
    } catch {
      /* storage unavailable — ignore, in-memory mode still works */
    }
    document.documentElement.setAttribute("data-theme", mode);
  }, [mode]);

  const colorMode = useMemo(
    () => ({
      mode,
      toggleColorMode: () =>
        setMode((prev) => (prev === "light" ? "dark" : "light")),
      setColorMode: (next) =>
        setMode(next === "dark" ? "dark" : "light"),
    }),
    [mode]
  );

  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
  return [theme, colorMode];
};
